import FormLabelInput from "../labels/form.label.input";
import HelpPopover from "../../popover/help.popover.component";
import { useState } from "react";

const FormTextInput = ({ className, ...otherProps }) => {
  const [showPopover, setShowPopover] = useState(false);
  return (
    <div className={`${className ? className : "w-full"}`}>
      <div className="flex flex-row justify-between">
        <FormLabelInput>
          {otherProps.label}:
          {otherProps?.required && <span className="text-red-700 ml-1">*</span>}
        </FormLabelInput>
        {otherProps?.help && (
          <HelpPopover classNames={otherProps?.help?.classNames}>
            <div className="whitespace-nowrap p-2">
              {otherProps?.help?.text}
            </div>
          </HelpPopover>
        )}
      </div>
      <input
        type="text"
        {...otherProps}
        className="w-full text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none"
      />
    </div>
  );
};

export default FormTextInput;
